import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './scss/index.scss';
import { registerSW } from 'virtual:pwa-register';
import './pwa/install.js'; // catch the browser's install event before any layout mounts
import App from './App.jsx';

// Service worker (offline field app). With registerType 'autoUpdate' the page reloads itself as soon as a newly
// deployed version takes over, so nobody keeps running a stale cached build; long-open tabs check hourly.
registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (registration) setInterval(() => registration.update(), 60 * 60 * 1000);
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
